// Lightweight local search helpers for reusable filtering across tables.
// Tokens: split on whitespace; all tokens must be present in any field text.

const toText = (value) => {
  if (value == null) return '';
  if (Array.isArray(value)) return value.map(toText).join(' ');
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'object') {
    // Avoid noisy [object Object]; prefer selected object fields via accessors.
    try {
      return JSON.stringify(value);
    } catch (_) {
      return '';
    }
  }
  return String(value);
};

export const tokenize = (query) =>
  (query || '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

export const searchItems = (items, query, { fields = [], customMatcher } = {}) => {
  if (!Array.isArray(items)) return [];
  const tokens = tokenize(query);
  if (tokens.length === 0) return items;

  const getters = fields.map((field) => {
    if (typeof field === 'function') return field;
    return (item) => (item && field in item ? item[field] : item?.[field]);
  });

  return items.filter((item) => {
    if (customMatcher) return customMatcher(item, tokens);
    const haystack = getters
      .map((fn) => toText(fn(item)))
      .join(' ')
      .toLowerCase();
    return tokens.every((token) => haystack.includes(token));
  });
};

const searchUtils = {
  tokenize,
  searchItems
};

export default searchUtils;

// Usage:
// const filtered = searchItems(data, query, { fields: ['name', 'notes', (row) => row.owner?.username] });
